import { createContext } from 'react';

/** Retained for layout compatibility; slider values remain editable in every context. */
export const CompactControlContext = createContext(false);
